export class IssuedTicket {
  driveId: number;
  ticketId: number;
  agencyTicketId: string;
  bookingId: number;
  ticketType: string;
  firstName?: string;
  lastName?: string;
  fromStationId: string;
  fromStationName: string;
  fromStationArrival: Date;
  fromStationDeparture: Date;
  toStationId: string;
  toStationName: string;
  toStationArrival: Date;
  toStationDeparture: Date;
  segment: number;
  isReturn: boolean;
  hasSeat: boolean;
  hasReservation: boolean;
  seatNumber: string;
  hasTicket: boolean;
  expiryDate: Date;
  lastStatus: string;
  confirmed?: boolean;
  carrierLogoUUID?: string;
  isReservable: boolean;

  // ak je hasReservation and has Ticket onda dialog bira cancel svega ili samo rezervacije

  constructor(data?: IssuedTicketBE) {
    if (data) {
      Object.assign(this, data);
      this.fromStationArrival = new Date(data.fromStationArrival);
      this.fromStationDeparture = new Date(data.fromStationDeparture);
      this.toStationArrival = new Date(data.toStationArrival);
      this.toStationDeparture = new Date(data.toStationDeparture);
      this.expiryDate = new Date(data.expiryDate);
    }
  }

  getStatus() {
    switch (this.lastStatus) {
      case '0':
        return 'Kreirana';
      case '1':
        return 'Valjana';
      case '2':
        return 'Poništena';
      case '3':
        return 'Iskorištena';
      case '4':
        return 'U tijeku';
    }
  }
}

interface IssuedTicketBE {
  driveId: number;
  ticketId: number;
  agencyTicketId: string;
  bookingId: number;
  ticketType: string;
  firstName?: string;
  lastName?: string;
  fromStationId: number;
  fromStationName: string;
  fromStationArrival: string;
  fromStationDeparture: string;
  toStationId: number;
  toStationName: string;
  toStationArrival: string;
  toStationDeparture: string;
  segment: number;
  isReturn: boolean;
  hasSeat: boolean;
  hasReservation: boolean;
  hasTicket: boolean;
  expiryDate: string;
  lastStatus: string;
  confirmed?: boolean;
  carrierLogoUUID?: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/model/IssuedTicket.ts